import { BreadcrumbItem, Breadcrumb as IOBreadcrumb } from '@doda/io-react/pc';
import { FC } from 'react';
import { BreadCrumb } from '@doda/common/src/interfaces/breadCrumb';
import classnames from 'classnames';
import styles from './index.module.scss';

/**
 * BreadcrumbのProps
 * @param breadcrumbData パンくずリストデータ
 */
interface Props {
  breadcrumbData: BreadCrumb[];
}

export const Breadcrumb: FC<Props> = ({ breadcrumbData }) => {
  return (
    <IOBreadcrumb>
      {breadcrumbData.map(({ breadCrumbText, breadCrumbLink, splitFlg }, i) => {
        return (
          <BreadcrumbItem
            className={classnames({ [styles.split]: splitFlg })}
            href={i === breadcrumbData.length - 1 ? undefined : breadCrumbLink}
            key={i}
          >
            {breadCrumbText}
          </BreadcrumbItem>
        );
      })}
    </IOBreadcrumb>
  );
};
